// import Proto from 'generated/proto/proto';
import * as Proto from 'generated/freeform_pb';

export type FFObject = Proto.FFObject;

function base64Array(str: string): Uint8Array {
  const binary_string = window.atob(str);
  const len = binary_string.length;
  const bytes = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  }
  return bytes;
}

export function fromProtobufStr(messageString: string): FFObject {
  return Proto.FFObject.deserializeBinary(base64Array(messageString));
}


/**
 * Returns the text of a text FFObject as a concatenated string, or null if not
 * a text object.
 */
export const extractText = (obj: Proto.FFObject) => {
  if (obj.getText() != null) {
    return obj.getText()?.getSectionsList()?.map(s => s.getText()).join('');
  }
  if (obj.getNewText() != null) {
    return obj.getNewText()?.getRunsList()?.map(s => s.getText()).join('');
  }
  return null;
};
